// material-ui
import { useColorScheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

// project imports
import IconButton from '@/components/@extended/IconButton';
import { ThemeMode } from '@/theme/config';

// assets
import BulbOutlined from '@ant-design/icons/BulbOutlined';
import BulbFilled from '@ant-design/icons/BulbFilled';

// ==============================|| HEADER CONTENT - THEME MODE TOGGLE ||============================== //

export default function ThemeModeToggle() {
  const { mode, colorScheme, setMode } = useColorScheme();

  // resolved scheme (handles mode === 'system')
  const isDark = (colorScheme ?? mode) === ThemeMode.DARK;

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Tooltip title={isDark ? 'Mod luminos' : 'Mod întunecat'}>
        <IconButton
          color="secondary"
          variant="light"
          sx={{ color: 'text.primary', bgcolor: 'transparent' }}
          aria-label="Comută tema luminos/întunecat"
          onClick={() => setMode(isDark ? ThemeMode.LIGHT : ThemeMode.DARK)}
        >
          {isDark ? <BulbFilled /> : <BulbOutlined />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
